module.exports = __webpack_public_path__ + "img/jc.24965067.png";